$(document).ready(function() {



    
$('.banner-lists').slick({
slidesToShow: 1,
infinite: true,
slidesToScroll: 1,
dots: false,
arrows: true,
focusOnSelect: true,
responsive: [
{
    breakpoint: 550,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            infinite: false,
        }
    }
]
});

$(".reviews-lists").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
     responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
          arrows: false,
          dots: true,
        }
      }
    ]
  });

  $(".products-slider .product-list").slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1320,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      }
    ]
  });

});



 // tabbed content
  // http://www.entheosweb.com/tutorials/css/tabs.asp
  $(".tab-container .tab_content").hide();
  // $(".tab-container .tab_content:first").show();
  $('.tab-container').each(function(k,v){
    $(v).find('.tab_content:first').show();
  });
  
  /* if in tab mode */
  $("ul.tabs li").click(function() {
    var parent = $(this).parents('.tab-container');
  
    $(parent).find(".tab_content").hide();
    var activeTab = $(this).attr("rel");
    $(parent).find("#"+activeTab).fadeIn();
  
    $(parent).find("ul.tabs li").removeClass("active");
    $(this).addClass("active");
  
    $(parent).find(".tab_drawer_heading").removeClass("d_active");
    $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
    setTimeout(() => {
      $('.product-list').slick('refresh');
    }, 1000);
  });
  /* if in drawer mode */
  $(".tab_drawer_heading").click(function() {
    var parent = $(this).parents('.tab-container');
  
    $(parent).find(".tab_content").hide();
    var d_activeTab = $(this).attr("rel");
    $(parent).find("#"+d_activeTab).fadeIn();
  
    $(parent).find(".tab_drawer_heading").removeClass("d_active");
    $(this).addClass("d_active");
  
    $(parent).find("ul.tabs li").removeClass("active");
    $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
    setTimeout(() => {
      $('.product-list').slick('refresh');
    }, 2000);
  });
  
  $(".coll-tags").removeClass('show-tags');
   $(".coll-tags .button").on('click',function(e){
     e.preventDefault();
	  $(".tags").slideToggle(300);
   });
  /* Extra class "tab_last"
     to add border to right side
     of last tab */
  $('ul.tabs li').last().addClass("tab_last");


  // mobile Tab
  $(document).off('click', '.select-label').on('click', '.select-label', function (e) {
    e.preventDefault();
      if($(this).parent().hasClass('active')){
        $(this).parent().removeClass('active');
      }else{
        $('.dropdown').removeClass('active');
        $(this).parent().addClass('active');
      }
  });
  $(document).on('click','.dropdown-list li', function () {
      $(this).parents('.dropdown').find('.select-label_inner').text($(this).text());
      $(this).parents('.dropdown').removeClass('active');
      var variant_id = $(this).data('value');
      $(this).parents('.main_variant_div').parent().find('.product-variant-id').val(variant_id);
  });







//footer accordion
$(document).ready(function () {
  function contactAccordion() {
    if (window.innerWidth <= 550) {

      $(".contactInfo .title_block").off("click").on("click", function () {
        const $parent = $(this).closest(".contactInfo");

        $parent.find(".contacttopInfo, .contactbtmInfo").slideToggle();
        $(".ftrcenterBtm").slideToggle();
        $(this).toggleClass("active");
      });

    } else {

      // Remove click event
      $(".contactInfo .title_block").off("click");

      // Reset to desktop/default state
      $(".contactInfo .contacttopInfo, .contactInfo .contactbtmInfo").show();
      $(".ftrcenterBtm").show();
      $(".contactInfo .title_block").removeClass("active");
    }
  }

  // Initial load
  contactAccordion();

  // Run when screen size changes
  $(window).on("resize", function () {
    contactAccordion();
  });

  
});

//sticky-menu-click
const stickyMenuToggle = document.querySelector(".sticky-menu-toggle"),
	menuDrawer = document.querySelector(".btn-menu-canvas");
stickyMenuToggle && menuDrawer && stickyMenuToggle.addEventListener("click", function(e) {
	e.preventDefault(), menuDrawer.click()
});

//scroll-snapping js
const track = document.querySelector('[class*="ai-crowdsourced-campaigns__grid"]');
if (track) {
const cards = Array.from(track.children);
const prevBtn = document.getElementById("cs-prevBtn");
const nextBtn = document.getElementById("cs-nextBtn");

function getCurrentIndex() {
  const trackLeft = track.getBoundingClientRect().left;

  let closestIndex = 0;
  let closestDistance = Infinity;

  cards.forEach((card, index) => {
    const cardLeft = card.getBoundingClientRect().left;
    const distance = Math.abs(cardLeft - trackLeft - 8);

    if (distance < closestDistance) {
      closestDistance = distance;
      closestIndex = index;
    }
  });

  return closestIndex;
}

function scrollToCard(index) {
  const safeIndex = Math.max(0, Math.min(index, cards.length - 1));

  const cardLeft = cards[safeIndex].offsetLeft;

  track.scrollTo({
    left: cardLeft,
    behavior: "smooth"
  });
}

prevBtn.addEventListener("click", () => {
  console.log("clicked");
  scrollToCard(getCurrentIndex() - 1);
});

nextBtn.addEventListener("click", () => {
  scrollToCard(getCurrentIndex() + 1);
});
}